var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"lazy-image",class:{'lazy-image--deferred': (_vm.defer && !_vm.loaded)},attrs:{"loading":_vm.loaded ? 'eager' : 'lazy',"src":_vm.source},on:{"error":_vm.handleError}})}
var staticRenderFns = []

export { render, staticRenderFns }